import { PackageStatusDetails } from 'src/app/core/models/package-status-details.model';

export const CONSTANTS = {
  HEADER: $localize`Package Status Details`,
  LABELS: {
    TRACKING_NUMBER: $localize`Tracking Number` + ':',
    REASON: $localize`Reason` + ':',
    EQUIPMENT_NUMBER: $localize`Equipment Number` + ':',
    SCAN_TIME: $localize`Scan Time:`,
    DESTINATION: $localize`Destination Country` + ':',
    SORT_CODE: $localize`Sort Code` + ':',
    EQUIPMENT_TYPE: $localize`Equipment Type` + ':',
    MOVEMENT: $localize`Movement` + ':',
    USER_ID: $localize`User Id` + ':',
    LOAD_CHART: $localize`Load Chart` + ':',
    STATUS: $localize`Status` + ':',
    SORT_DATE: $localize`Sort Date` + ':',
    LOAD_KEY: $localize`Dest Load Key:`,
    FLEX: $localize`Flex` + ':',
    CHILD_LOAD: $localize`Child Load Chart:`,
  },
};

export const MOCK_STATUS_DATA: PackageStatusDetails = {
  trackingNumber: '',
  reason: 'REASON',
  equipmentNumber: 0,
  scanTime: 'SCAN TIME',
  destination: 'DESTINATION',
  sortCode: 'SORT CODE',
  equipmentType: 'EQUIPMENT TYPE',
  movement: 'MOVEMENT',
  userId: 'USER ID',
  loadChart: 'LOAD CHART',
  status: 'STATUS',
  sortDate: 'SORT DATE',
  loadKey: 'LOAD KEY',
  flex: 'FLEX',
  childLoad: 'CHILD LOAD',
};

export type PackageModalData = {
  trackingNumber: string;
  packageStatusDetails: PackageStatusDetails;
  isSmartValue: boolean;
};
